import {Col, Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-direction: column;
    padding: 16px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const StatsHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: flex-start;
        gap: 16px;
    }
`;

export const AverageOrderTimeRow = styled(Row)`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    max-width: 400px;
`;
export const AvgOrderTimeLabel = styled.div`
    background-color: #aeff01;
    min-height: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 700;
    float: left;
    position: relative;
    width: calc(68% - 24px);
    border-radius: 5px;
    &::after {
        position: absolute;
        top: 0px;
        content: "";
        z-index: -1;
        height: 100%;
        width: 60%;
        background: #aeff01;
        right: 0;
        transform-origin: bottom right;
        transform: skewX(-20deg);
    }
`;
export const AvgOrderTimeValue = styled.div`
    background-color: #000000;
    min-height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 5px;
    font-weight: 700;

    float: right;
    position: relative;
    width: calc(32% - 24px);
    &::after {
        position: absolute;
        top: 0px;
        content: "";
        z-index: -1;
        height: 100%;
        width: 20%;
        background: #000000;
        left: 0;
        transform-origin: top left;
        transform: skewX(-20deg);
        background: #000;
        z-index: 44;
        color: "white";
    }
`;

export const AvgDeliveryTimeImg = styled.img`
    margin-left: 10px;
    margin-right: 10px;
`;
export const DeliveryStatsRow = styled(Row)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    width: 100%;
    gap: 16px;
    margin-top: 16px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
    }
`;

export const DeliveryStatsBlock = styled(Col)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 16px 8px;
    max-width: 184px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    background-color: #f7f7f7;
    border-radius: 5px;
    cursor: ${$props => ($props.onClick ? "pointer" : "default")};
    transition: background-color 0.3s;
    &:hover {
        background-color: ${$props => ($props.onClick ? "#eaeaea;" : "#f7f7f7")};
    }

    @media screen and (max-width: 768px) {
        max-width: 100%;
        padding: 12px 8px;
    }

    @media screen and (max-width: 480px) {
        padding: 10px 6px;
    }
`;

export const DeliveryStatsIcon = styled.img``;
export const DeliveryStatsValue = styled.div`
    font-weight: 700;
    font-size: 24px;
`;
export const DeliveryStatsLabel = styled.div`
    text-align: center;
    font-size: 14px;
    font-weight: 600;
`;
